<template>
  <InputAddress
      v-model="data"
      :db-override="db"
      :question-override="question"
      :jsErrorsData="jsErrors"
      @jsErrors="jsErrors=$event"
  />
</template>

<script>
import InputAddress from "../../inputs/InputAddress";

export default {
  name: 'IntroducerAddress',
  components: {
    InputAddress
  },
  props: {
    value: {
      type: Object,
      required: false
    },
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'What is your business address?'
      },
      db: {
        saveLocation: 'introducer_address',
        saveField: 'address',
        deleteLocation: 'introducer_address'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
      show: this.$parent.$parent.$data.show
    }
  }
}
</script>
